//CSS
import "../../Components/Page/Page.css";
import engine from "../../Images/OurStory/Wankel.png";
import DroneEngine1 from "../../Images/ElfTech/DroneEngine.png";
import DroneEngineReg from "../../Images/ElfTech/DroneEngineReg.png";

//React
import React from "react";
import SecHeader from "../../Components/SecHeader/SecHeader";
import SubSection from "../../Components/Section/SubSection";
import ImageComp from "../../Components/ImageContainer/ImageComp";

const DroneEngine: React.FC = () => {
    return (
        <div id="Goals" className="sectionContainer">
            <SecHeader title="Drone Engines" />
            <SubSection>
                <div className="inv-items">
                    <div className="inv-item">
                        <p className="inv-item-body">
                            <h4 className="inv-item-title">Both</h4>
                            <ul>
                                <li>2-stroke, SI, petrol + oil</li>
                                <li>Air cooled, 2-cylinder boxers</li>
                                <li>Crankcase scavenged</li>
                                <li>Carburetor + magneto</li>
                                <li>Max power is at 6,000 rpm</li>
                                <li>Similar parts counts & unit costs</li>
                                <li>Same dry weights = 17 kg / 35-lb.</li>
                            </ul>
                        </p>
                    </div>
                </div>
            </SubSection>
            <SubSection>
                <ImageComp imageSource={DroneEngine1} width={"Clamp(18rem, 25vw, 36rem)"} />
                <ImageComp imageSource={DroneEngineReg} width={"Clamp(18rem, 25vw, 36rem)"} />
            </SubSection>
            <SubSection isSplit={true}>
                <div className="inv-items">
                    <div className="inv-item">
                        <p className="inv-item-body">
                            <h4 className="inv-item-title">Reference Engine</h4>
                            <ul>
                                <li>  495cc displacement, 48cm wide</li>
                                <li>  Uses ports to time scavenging</li>
                                <li>  Only 322cc of displacement can
                                    be used for power or compression</li>
                                <li>  Makes loud and hot exhaust</li>
                                <li>  Very little over-expansion</li>
                                <li>  Has rocking & torsion vibrations</li>
                                <li>  Max power = 33-kW / 44-hp.</li>
                                <li>  Max efficiency = 31% (264 g/kWh)</li>
                                <li>  Max average piston speed = 11 m/s</li>
                                <li>  High maintenance & Short lifespan</li>


                            </ul>
                        </p>
                    </div>
                </div>
                <div className="inv-items">
                    <div className="inv-item">
                        <p className="inv-item-body">
                            <h4 className="inv-item-title">ELF-TechTM Alternative</h4>
                            <ul>
                                <li> 466cc displacement, & only 31cm wide</li>
                                <li> 100% of the 466cc displacement can
                                    be used for power or compression</li>
                                <li> Has Quieter and cooler exhaust</li>
                                <li> Has lower vibration & lower friction</li>
                                <li> 150% over-expansion is possible</li>
                                <li> Max power = 45-kW / 60-hp.</li>
                                <li> Max efficiency = 37% (221 g/kWh)</li>
                                <li> Max average piston speed = 9 m/s</li>
                                <li> Longer lasting & better balance</li>
                            </ul>
                        </p>
                    </div>
                </div>
            </SubSection>
        </div>
    );
};

export default DroneEngine;
